import { render, staticRenderFns } from "./RecordApp.vue?vue&type=template&id=127a1c4b&scoped=true&"
import script from "./RecordApp.vue?vue&type=script&lang=ts&"
export * from "./RecordApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a1c4b",
  null
  
)

export default component.exports